import { useForm } from "react-hook-form"; 
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation, useQueryClient } from "react-query"; 
import toast from "react-hot-toast"; 
import { useNavigate } from "react-router-dom"; 
import { Controller } from "react-hook-form";
import { Card, Flex, Box, Text, Button } from "@radix-ui/themes"; 
import { createAcademicYear } from "../../services/school/academicYear/createAcademicYear";
import { CriarAcademicYearFormValidation } from "./CriarAcademicYearFormValidation";
import { AcademicYearType } from "../../types/AcademicYear";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { routes } from "../../routes";


export const CriarAcademicYear = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm< {year:number} >({
    resolver: yupResolver( CriarAcademicYearFormValidation),
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
  });


  const mutation = useMutation({
    mutationFn: createAcademicYear,
    onSuccess: () => {
      toast.success("Ano letivo criado com sucesso!");
      queryClient.invalidateQueries("academicYears-pagination");
      navigate(routes.academicYears); 
    },
    onError: (error: any) => {
      toast.error(error?.message ?? "Erro ao criar ano letivo");
    },
  });

 const onSubmit = handleSubmit(async (data) => {

       await mutation.mutate({ year: `${data.year}` });
    });


  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1" className="max-w-md mx-auto p-4">
        <Flex direction="column" gap="4">
          <Box>
            <Text as="p" size="2" mb="2">
              Introduza o ano lectivo.
            </Text>
          </Box>

          
          <TextFieldComponent
            control={control}
            errors={errors}
            name="year"
            label="Ano lectivo"
          //   fieldProps={{}}
          />

          <Button type="submit" disabled={mutation.isLoading}>
            {mutation.isLoading ? "A criar..." : "Criar ano"}
          </Button>
        </Flex>
      </Card>
    </form>
  );
};
